function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none",
      fill: "#2C2C2C"
    },
    d: "M150,12.5c4.5,0,8.1,3.6,8.1,8.1V47c3.1,1.7,5.7,4.2,7.4,7.4h13.9 c4.5,0,8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1l0,0h-13.9c-1.7,3.1-4.2,5.7-7.4,7.4v59.5c0,10.7-8.2,19.6-18.9,20.6l-1.8,0.1H78 c-1.7,3.1-4.2,5.7-7.4,7.4v13.9c0,4.5-3.6,8.1-8.1,8.1s-8.1-3.6-8.1-8.1v-13.9c-3.1-1.7-5.7-4.2-7.4-7.4H20.6 c-4.5,0-8.1-3.6-8.1-8.1s3.6-8.1,8.1-8.1H47c1.7-3.2,4.2-5.7,7.4-7.4v-64H20.6c-4.5,0-8.1-3.6-8.1-8.1s3.6-8.1,8.1-8.1l0,0h33.8 V20.6c0-4.5,3.6-8.1,8.1-8.1s8.1,3.6,8.1,8.1l0,0v33.7h63.9c1.7-3.1,4.2-5.7,7.4-7.4V20.6C141.9,16.1,145.5,12.5,150,12.5z  M62.5,141.2c-4.8,0-8.8,3.9-8.8,8.7s3.9,8.8,8.7,8.8l0,0c4.8,0,8.7-3.9,8.7-8.8C71.2,145.2,67.3,141.3,62.5,141.2z M134.5,70.6 H70.6v63.9c3.2,1.7,5.7,4.2,7.4,7.4h59.5c2.1,0,3.9-1.5,4.3-3.5l0.1-0.9V78C138.7,76.3,136.2,73.8,134.5,70.6z M150,53.8 c-4.8,0-8.8,3.9-8.8,8.7s3.9,8.8,8.8,8.8l0,0c4.8,0,8.8-3.9,8.8-8.8C158.8,57.7,154.8,53.8,150,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2C2C"
    },
    d: "M62.5,186.1c-3.7,0-6.7-3-6.7-6.7v-14.7l-0.8-0.4c-2.9-1.5-5.3-3.9-6.8-6.8l-0.4-0.8H20.6 c-3.7,0-6.7-3-6.7-6.7s3-6.7,6.7-6.7h27.2l0.4-0.8c1.5-2.9,3.9-5.2,6.8-6.8l0.8-0.4V69.2H20.6c-3.7,0-6.7-3-6.7-6.7 c0-1.8,0.7-3.5,2-4.7c1.3-1.3,3-2,4.7-2h35.2V20.6c0-3.7,3-6.7,6.7-6.7s6.7,3,6.7,6.7v35.2h66.1l0.4-0.8c1.5-2.9,3.9-5.2,6.8-6.8 l0.8-0.4V20.6c0-3.7,3-6.7,6.7-6.7s6.7,3,6.7,6.7v27.2l0.8,0.4c2.9,1.5,5.3,3.9,6.8,6.8l0.4,0.8h14.7c3.7,0,6.7,3,6.7,6.7 s-3,6.7-6.7,6.7h-14.7l-0.4,0.8c-1.5,2.9-3.9,5.3-6.8,6.8l-0.8,0.4v60.4c0,10-7.5,18.3-17.6,19.1l-1.7,0.1H77.1l-0.4,0.8 c-1.5,2.9-3.9,5.3-6.8,6.8l-0.8,0.4v14.7C69.2,183.1,66.2,186.1,62.5,186.1z M62.5,139.8c-5.6,0-10.2,4.6-10.2,10.2 c0,5.6,4.6,10.2,10.2,10.2s10.2-4.6,10.2-10.2C72.7,144.4,68.1,139.8,62.5,139.8L62.5,139.8z M69.2,135.4l0.8,0.4 c2.9,1.5,5.3,3.9,6.8,6.8l0.4,0.8h60.4c2.7,0,5.1-1.9,5.7-4.6v-0.1l0.1-1V77.1l-0.8-0.4c-2.9-1.5-5.3-3.9-6.8-6.8l-0.4-0.8H69.2 V135.4z M150,52.3c-5.6,0-10.2,4.6-10.2,10.2s4.6,10.2,10.2,10.2s10.2-4.6,10.2-10.2S155.6,52.3,150,52.3z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTube);
export default __webpack_public_path__ + "static/media/tube.76ce34069180bb94763f3028f73680da.svg";
export { ForwardRef as ReactComponent };